import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from 'src/app/services/utility.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import * as moment from 'moment';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { AlertService } from 'src/app/services/alert.service';
import { ReportsService } from 'src/app/services/reports.service';
import { TripEntryService } from 'src/app/services/tripentry.service';
import { ShowDailyReportComponent } from '../showdailyreport/showdailyreport.component';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import { DateTimeAdapter } from 'ng-pick-datetime';
import * as _ from 'lodash';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { ActivatedRoute } from '@angular/router';
import { DepartmentBookingType } from 'src/enum/departmentbooking';

@Component({
  selector: 'app-waiting-list-report',
  templateUrl: './waiting-list-report.component.html',
  styleUrls: ['./waiting-list-report.component.scss']
})
export class WaitingListReportComponent implements OnInit {
  public DepartmentBookingType = DepartmentBookingType;
  form: FormGroup;
  dropdownSettings: any = {};
  vehicleList: any = [];
  tripTypeList: any[];
  CategoryTypeList: any[];
  url: string;
  clientId: any;
  scheduledEndmin: any;
  scheduledEndmax: any;
  vehicleRegNo: any;
  maxDate: Date;
  registrationNumbers: any[];
  regionList: any[];
  subdivisionList: any[];
  VehicleRegNoList: any[];
  divisionList: any[];
  filterregionList: any[];
  filterdivisionList: any[];
  filtersubdivisionList: any[];
  filterListsubdivisionList: any[];
  VehicleTypeList: any[];
  filterVehicleTypeList: any[];
  public RoleEnumType = RoleType;
  roleId: number;
  vehicalyearList: any[];
  filtervehicalyearList: any;
  currentMonth: number;
  currentYear: number;
  curyear: any;
  financialyearId: any;
  GoList: any[];
  filterGoList: any;
  goId: any;
  SchemeList: any[];
  filterSchemeList: any;
  schemeId: any;
  ComponentList: any[];
  filterComponentList: any;
  componentId: any;
  result: any;
  remainingAmount: number;
  ImplementList: any[];
  filterImplementList: any;
  filtercommunityList: any[];
  communityList: any[];
  mode: any;
  isdisabledproduct: boolean;
  isdisabled: boolean = false;
  productbtn: boolean;
  istabledisabled: boolean;
  languageType: any;
  villageIdList: any[];
  villageIdListCopy: any[];
  districtList: any[];
  filterListdistrict: any[];
  talukList: any[];
  filterListtaluk: any[];
  isShow: boolean;

  constructor(
    private formBuilder: FormBuilder, private reportsService: ReportsService,
    private alertService: AlertService,
    private vehicleService: VehicleService,
    private utilityService: UtilityService,
    public tripDialog: MatDialog,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private tripEntryService: TripEntryService,
    private subdivisionService: SubDivisionService,
    private userSessionService: UserSessionService,
    private cashBookingService: CashBookingService,
    private route: ActivatedRoute,
    dateTimeAdapter: DateTimeAdapter<any>
  ) {
    this.languageType = this.userSessionService.getLanguageType();
    this.roleId = this.userSessionService.roleId();
   }

   ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.initializeValidators();
    this.getLookupRegion(true);
    
    this.getCommuntyList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'regNo',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
    this.maxDate = new Date();
    this.scheduledEndmax = new Date();
    this.financialyearListLookup();
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      financialyearId: ["", Validators.required],
      goid: [null, Validators.required],
      schemeId: [null, Validators.required],
      componentId: [null, Validators.required],
      regionId: [null, Validators.required],
      divisionId: [null,],
      subDivisionId: [null,],
      community: ['', Validators.required],
      // districtId:['',Validators.required],
      // talukId:['',Validators.required],
      villageId:['',]
    });
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
  financialyearListLookup() {
    this.vehicleService.vehicletargetFinancialyear(true).subscribe((result) => {
      this.vehicalyearList = result
      this.filtervehicalyearList = this.vehicalyearList.slice();
      var financialYear = "";
      if (this.currentMonth >= 0 && this.currentMonth <= 2) {
        financialYear = "FY " + ((this.currentYear - 1).toString() + '-' + this.currentYear.toString().slice(-2));
      } else {
        financialYear = "FY " + ((this.currentYear).toString() + '-' + (this.currentYear + 1).toString().slice(-2));
      }
      this.curyear = this.filtervehicalyearList.find(i => i.value == financialYear);
      this.form.controls["financialyearId"].setValue(this.curyear.key);
      this.financialYearChange(this.form.value.financialyearId);
    })
  }
  financialYearChange(event: any) {
    this.financialyearId = this.form.value.financialyearId;
    this.divisionService.getGoListbyId(true, this.financialyearId).subscribe((result) => {
      this.GoList = [];
      this.GoList = result;
      this.filterGoList = result;
      if (this.filterGoList.length === 1) {
        this.form.controls["goid"].setValue(this.filterGoList[0].key);
        this.golistChange(this.form.value.goid);
      }
    });
  }
  golistChange(event: any) {

    this.goId = this.form.value.goid;
    this.divisionService.getSchemaListbyId(true, this.goId).subscribe((result) => {
      this.SchemeList = [];
      this.SchemeList = result;
      this.filterSchemeList = result;
      if (this.filterSchemeList.length === 1) {
        this.form.controls["schemeId"].setValue(this.filterSchemeList[0].key);
        this.schemaListChange(this.form.value.schemeId);
      }
    });
  }
  schemaListChange(event: any) {
    this.schemeId = this.form.value.schemeId;
    this.divisionService
      .getComponetListbyId(this.goId, this.schemeId, true)
      .subscribe((result) => {
        this.ComponentList = [];
        this.ComponentList = result;
        this.filterComponentList = result;
        this.filterComponentList = _.orderBy(this.filterComponentList, ['value'], ['asc']);
        if (this.filterComponentList.length === 1) {
          this.form.controls["componentId"].setValue(
            this.filterComponentList[0].key
          );
          this.componentListChange(this.form.value.componentId);
        }
      });
  }
  componentListChange(event: any) {

    this.componentId = this.form.value.componentId;
    this.divisionService.getdbtstatetargetmapping(true, this.financialyearId,DepartmentBookingType.AED, this.goId, this.schemeId, this.componentId).subscribe(res => {
      this.result = res;
      this.remainingAmount = this.result.subsidyAmount - this.result.stateSubsidyAmount;
    })
    this.divisionService
      .getfilteredProductList(true, this.financialyearId,DepartmentBookingType.AED, this.goId, this.schemeId, this.componentId)
      .subscribe((result) => {
        this.ImplementList = [];
        this.ImplementList = result;
        this.filterImplementList = result;
        this.filterImplementList = _.orderBy(this.filterImplementList, ['value'], ['asc']);

      });

  }


  getLookupRegion(refresh: boolean) {
    this.regionService.getLookUp(refresh).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
        const regionLength = this.regionList.length;
        if (regionLength === 1) {
          this.form.controls['regionId'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionId);
        }
      } 
    });
    
  }

  getCommuntyList() {
    this.cashBookingService.getcommunityLookup(true).subscribe((res) => {
      if (res) {
        this.communityList = [];
        this.filtercommunityList = [];
        this.communityList = res;
        this.communityList.unshift({key: 0, value: "All"});
        this.filtercommunityList = this.communityList.slice();


      }
    })
  }

  regionChange() {
    this.getLookupDivision(this.form.value.regionId);
    this.getVillageFarm();
    this.getLookupSubDivision(this.form.value.divisionId);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['subDivisionId'].setValue(0);
    this.form.controls['villageId'].setValue(0);
    this.villageIdList=[];
  }
  getLookupDivision(id) {
    this.divisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        this.filterdivisionList = this.divisionList.slice();
        const divisionLength = this.divisionList.length;
        if (divisionLength === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
          this.getLookupSubDivision(this.form.value.divisionId);

        }
      }
    })
  }
  // getDistrict() {
  //   var langType = this.languageType;
  //   this.cashBookingService.districtData(langType, true).subscribe(result => {
  //     if (result) {
  //       this.districtList = [];
  //       this.filterListdistrict = [];
  //       this.districtList = result;
  //       this.filterListdistrict = this.districtList.slice();
  //       const districtLength = this.districtList.length;
  //       if (districtLength === 1) {
  //         this.form.controls['districtId'].setValue(this.districtList[0].key);
  //         // this.getBlock();
  //       }
  //     }
  //   });
  // }
  // getTalukdata(){
  //   this.getTaluk();
  // }
  // getTaluk() {
  //   var langType = this.languageType;
  //   var districtID = this.form.value.districtId;
  //   this.cashBookingService.talukData(districtID, langType, true).subscribe(result => {
  //     if (result) {
  //       this.talukList = [];
  //       this.filterListtaluk = [];
  //       this.talukList = result;
  //       this.filterListtaluk = this.talukList.slice();
  //     }
  //   });
  // }
  getVillageFarm() {
    // var subDivision =this.form.value.subDivisionId;
    this.divisionService.getvillageListbyId(true,this.form.value.subDivisionId).subscribe(result => {
      if (result) {
        this.villageIdList = [];
        this.villageIdListCopy = [];
        this.villageIdList = result;
        this.villageIdListCopy = this.villageIdList.slice();
        const villageIdListlength = this.villageIdList.length;
        if(villageIdListlength === 1){
          this.form.controls['villageId'].setValue(this.villageIdList[0].key);
        }
      }
    });
  }
  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);
    this.form.controls['subDivisionId'].setValue(0);
    this.getVillageFarm();
    this.form.controls['villageId'].setValue(0);
   
  }
  getLookupSubDivision(id) {
    this.subdivisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filterListsubdivisionList = [];
        this.subdivisionList = result;
        this.filterListsubdivisionList = this.subdivisionList.slice();
        const subdivisionLength = this.subdivisionList?.length;
        if (subdivisionLength === 1) {
          this.form.controls['subDivisionId'].setValue(this.subdivisionList[0].key);
          // this.getVehicleList(this.form.value.subDivisionId, true);
    this.getVillageFarm();

        }
    this.getVillageFarm();

      }
    })
  }
  getvillage(){
    this.getVillageFarm();
    this.form.controls['villageId'].setValue(0);
  }

  clear() {
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.initializeValidators();
    this.getLookupRegion(true);
    
    this.getCommuntyList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'regNo',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
    this.maxDate = new Date();
    this.scheduledEndmax = new Date();
    this.financialyearListLookup();
  }
  showReport() {
    if (this.form.valid) {
      // if (this.form.value.regionId == null) {
      //   this.form.controls['regionId'].setValue(0);
      // }
      if (this.form.value.divisionId == null) {
        this.form.controls['divisionId'].setValue(0);
      }
      if (this.form.value.subDivisionId == null) {
        this.form.controls['subDivisionId'].setValue(0);
      }
      if (this.form.value.community == null) {
        this.form.controls['community'].setValue(0);
      }
      // if(this.roleId != 2){
      //   this.form.controls['regionId'].setValidators(Validators.required);
      //   this.form.controls['regionId'].updateValueAndValidity();
      //   this.form.controls['divisionId'].setValidators(Validators.required);
      //   this.form.controls['divisionId'].updateValueAndValidity();
      //   this.form.controls['subDivisionId'].setValidators(Validators.required);
      //   this.form.controls['subDivisionId'].updateValueAndValidity();
      //   this.form.controls['villageId'].setValidators(Validators.required);
      //   this.form.controls['villageId'].updateValueAndValidity();
      // }
      // if(this.roleId == 6){
      //   this.form.controls['subDivisionId'].clearValidators();
      //   this.form.controls['subDivisionId'].updateValueAndValidity();
      //   this.form.controls['villageId'].clearValidators();
      //   this.form.controls['villageId'].updateValueAndValidity();
      // }
      // if(this.roleId == 7){
      //   this.form.controls['villageId'].clearValidators();
      //   this.form.controls['villageId'].updateValueAndValidity();
      // }
      // if (this.form.value.VehicleRegNo == null) {
      //   this.form.controls['VehicleRegNo'].setValue(0);
      // }
      // const vehicleIdList = [];
      // let startDate = this.form.get('ScheduledStart').value;
      // // let endDate = this.form.get('ScheduledEnd').value;
      // const selectedVehicle = this.form.get('VehicleRegNo').value;
      // startDate = moment(startDate).format('YYYY-MM-DD');
      // // endDate = moment(endDate).format('YYYY-MM-DD');
      // if (selectedVehicle && selectedVehicle.length > 0) {
      //   selectedVehicle.forEach(element => {
      //     vehicleIdList.push(element.id);
      //   });
      // }


      const data = {
        // RevenuTs: startDate,
        // // endTs: endDate,
        // vehicleId: vehicleIdList,

        componentId: this.form.value.componentId,
        componentIdvalue:  _.find(this.ComponentList, ['key', (this.form.value.componentId)])?.value,
        financialyearId: this.form.value.financialyearId,
        financialyearIdvalue:  _.find(this.vehicalyearList, ['key', (this.form.value.financialyearId)])?.value,
        schemeId:this.form.value.schemeId,
        schemeIdvalue: _.find(this.SchemeList, ['key', (this.form.value.schemeId)])?.value,
        divisionId: this.form.value.divisionId,
        // divisionId:  _.find(this.divisionList, ['key', (this.form.value.divisionId)])?.value,
        villageId:this.form.value.villageId,

        regionId: this.form.value.regionId,
        subDivisionId: this.form.value.subDivisionId,
        community: this.form.value.community,
        communityvalue:  _.find(this.communityList, ['key', (this.form.value.community)])?.value,

        // vehicleTypeId: this.form.value.vehicleTypeId,
        ReportType: 26
      }
      // const data = {
      //   clientId: 1,
      //   startTs: '2020-11-20',
      //   endTs: '2020-11-27',
      //   vehicleId: [1,2],
      //   tripType: 1,
      //   reportType: 2,
      //   downloadType: 1
      // }
      const dialogRef = this.tripDialog.open(ShowDailyReportComponent, {
        autoFocus: false,
        disableClose: true,
        width: '90%',
        height: '90%',
        panelClass: 'mat-dialog-report',
        data
      })
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.validateFormControl();
    }
  }

}
